<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trail="trails[0].trail" :subTrail="` > ${trails[1].trail}`" :href="trails[0].href + userType"></crumbs>
    <div class="main-view">
      <h3>{{MediaId != 0? '编辑媒体商':'添加媒体商'}}</h3>
      <!--基本信息-->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div class="view-form-list">
          <label class="list-title">基本信息</label>
          <ul>
            <li>
              <el-form-item label="媒体商类型" prop="Nature">
                <el-select v-model="ruleForm.Nature" placeholder="请选择" size="small" @change="changeMediaType">
                  <el-option
                    v-for="item in mediaTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="媒体商姓名：" prop="Name">
                <el-input v-model="ruleForm.Name" placeholder="请输入媒体商姓名" size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="媒体商邮箱：" prop="UserEmail">
                <el-input v-model="ruleForm.UserEmail" placeholder="请输入媒体商邮箱" size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="电话号码：" prop="TelePhone">
                <el-input v-model="ruleForm.TelePhone" placeholder="请输入电话号码" size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="所属媒介：" prop="SourcemanId">
                <el-select v-model="ruleForm.SourcemanId" placeholder="请选择" size="small">
                  <el-option
                    v-for="item in mediumList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="媒体运营：" prop="SourceOperatorId">
                <el-select v-model="ruleForm.SourceOperatorId" placeholder="请选择" size="small">
                  <el-option
                    v-for="item in operatingList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="媒体商密码：" prop="UserPassword">
                <el-input v-model="ruleForm.UserPassword" type="password" placeholder="如需修该密码，请填写" size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="状态：" prop="mediaStatus">
                <el-select v-model="ruleForm.Status" placeholder="请选择" size="small">
                  <el-option
                    v-for="item in mediaStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="合同公司：" prop="mediaCompany">
                <el-select v-model="ruleForm.ContractCompany" placeholder="请选择" size="small">
                  <el-option
                    v-for="item in mediaCompanyList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </li>
          </ul>
        </div>

        <!--公司信息-->
        <div class="view-form-list">
          <label class="list-title">公司信息</label>
          <ul>
            <li>
              <el-form-item label="公司名称：" prop="CompanyName">
                <el-input v-model="ruleForm.CompanyName " :disabled="ruleForm.Nature == 0" placeholder="请输入公司名称"
                          size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="公司地址：" prop="CompanyAddress">
                <el-input v-model="ruleForm.CompanyAddress" placeholder="请输入公司地址" size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="公司电话：" prop="CompanyTelePhone">
                <el-input v-model="ruleForm.CompanyTelePhone" placeholder="请输入公司电话" size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="营业执照号：" prop="BusiLicenseNum">
                <el-input v-model="ruleForm.BusiLicenseNum" :disabled="ruleForm.Nature == 0" placeholder="请输入营业执照号"
                          size="small"></el-input>
              </el-form-item>
            </li>
            <li v-if="ruleForm.Nature == 0">
              <el-form-item label="身份证号码：" prop="IdCardNumber">
                <el-input v-model="ruleForm.IdCardNumber" placeholder="请输入身份证号码" size="small"></el-input>
              </el-form-item>
            </li>
          </ul>
        </div>

        <!--开户行信息-->
        <div class="view-form-list">
          <label class="list-title">开户行信息</label>
          <ul>
            <li v-if="ruleForm.Nature == 0">
              <el-form-item label="开户名称：" prop="BankUserName">
                <el-input v-model="ruleForm.BankUserName" placeholder="请输入开户名称" size="small"></el-input>
              </el-form-item>
            </li>

            <li v-if="ruleForm.Nature == 1">
              <el-form-item label="开户公司：" prop="AccountOpenCompany">
                <el-input v-model="ruleForm.AccountOpenCompany" placeholder="请填写开户公司名称" size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="开户银行支行：" prop="AccountBranch">
                <el-input v-model="ruleForm.AccountBranch" placeholder="请输入银行支行" size="small"></el-input>
              </el-form-item>
            </li>
            <li>
              <el-form-item label="银行账号：" prop="BankAccount">
                <el-input v-model="ruleForm.BankAccount" placeholder="请输入银行账号" size="small"></el-input>
              </el-form-item>
            </li>
          </ul>
        </div>

        <!--附件信息-->
        <div class="view-form-list">
          <label class="list-title">开户行信息</label>
          <div class="form-upload-img">
            <div class="upload-left">
              <div class="update">
                <label>{{ ruleForm.Nature === 0? '身份证正面':'营业执照'}}</label>
                <el-upload
                  class="upload-demo"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload1">
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </div>
              <div class="upload-result-img">
                <img v-if="imageUrl1 && ruleForm.Nature == 0" :src="imageUrl1" alt="" @click="imgView(1)">
                <img v-if="imageUrl3 && ruleForm.Nature == 1" :src="imageUrl3" alt="" @click="imgView(1)">
                <i v-if="!imageUrl1 && ruleForm.Nature == 0" class="el-icon-picture">{{imageUrl1}}</i>
                <i v-if="!imageUrl3 && ruleForm.Nature == 1" class="el-icon-picture"></i>
              </div>

            </div>
            <div class="upload-right">
              <div class="update">
                <label>{{ ruleForm.Nature === 0? '身份证反面':'开户许可证'}}</label>
                <el-upload
                  class="upload-demo"
                  action=""
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload2">
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </div>
              <div class="upload-result-img">
                <img v-if="imageUrl2 && ruleForm.Nature == 0" :src="imageUrl2" alt="" @click="imgView(2)">
                <img v-if="imageUrl4 && ruleForm.Nature == 1" :src="imageUrl4" alt="" @click="imgView(2)">
                <i v-if="!imageUrl2 && ruleForm.Nature == 0" class="el-icon-picture"></i>
                <i v-if="!imageUrl4 && ruleForm.Nature == 1" class="el-icon-picture"></i>
              </div>
            </div>
          </div>
        </div>
      </el-form>


      <div class="form-btn">
        <el-button @click="back">返回</el-button>
        <el-button type="primary" @click="EditUserDetail('ruleForm')">保存</el-button>
      </div>


      <!--//图片预览碳层-->
      <el-dialog
        :visible.sync="imgPreviewShow"
        class="preview-img"
        width="65%">
        <div slot="title" class="dialog-footer">
          <img v-if="imgPreview" :src="imgPreview">
        </div>
      </el-dialog>


    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  // 面包屑
  import crumbs from "../public/crumbs/crumbs";
  // 审核弹层
  import confirmDialog from "../public/confirm-dialog";
  // 格式化时间
  import {formatDateAll} from "common/js/common";

  import merge from 'webpack-merge'
  // api
  import {
    // 获取广告运营接口
    GetUserAdOperatorUser,
    // 获取媒介接口
    getSourceman,
    // 媒体运营
    GetSourceOperatorUserList,
    //获取合同公司
    GetContractCompanyEnum,
    //获取媒体商信息接口
    GetMediaUserInfo,
    // 添加、修改媒体商信息接口
    EditUserDetail,
    // 上传证件照接口
    UploadImg
  } from "api/customerManagement";

  export default {
    data() {
      return {
        // 面包屑
        trails: [
          {
            trail: "媒体商客户",
            href: "/iad_customer/list?usertype="
          },
          {
            trail: "添加媒体商",
            href: ""
          }
        ],
        mediaTypeList: [{
          value: 1,
          label: '公司'
        }, {
          value: 0,
          label: '个人'
        }
        ],
        // 所属媒介
        mediumList: [{
          value: 0,
          label: '请选择'
        }],
        // 媒体运营
        operatingList: [{
          value: 0,
          label: '请选择'
        }],
        //状态
        mediaStatusList: [{
          value: 0,
          label: '未上传'
        }, {
          value: 1,
          label: '待通过'
        }, {
          value: 2,
          label: '未通过'
        }, {
          value: 3,
          label: '已通过'
        }],
        //合同公司
        mediaCompanyList: [],
        imageUrl1: '',
        imageUrl2: '',
        imageUrl3: '',
        imageUrl4: '',
        ruleForm: {},
        oldRuleForm: {},
        rules: {
          Name: [
            {required: true, message: '请填写媒体商姓名', trigger: 'blur'}
          ],
          UserEmail: [
            {required: true, message: '请填写媒体商邮箱', trigger: 'blur'},
            {type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']}
          ],
          TelePhone: [
            {required: true, message: '请填写手机号码', trigger: 'blur'},
            {pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/ || /^1(3|4|5|7|8)\d{9}$/, message: '请输入正确的电话号码', trigger: ['blur', 'change']}
          ],
          SourcemanId: [
            {required: true, message: '请选择所属媒介', trigger: 'blur'}
          ],
          SourceOperatorId: [
            {required: true, message: '请选择媒体运营', trigger: 'blur'}
          ],
          UserPassword: [
            {min: 6, message: '密码长度不能小于六位数', trigger: ['blur', 'change']},
            {pattern: /^.*[^\d].*$/, message: '密码不能设为纯数字组成', trigger: ['blur', 'change']}
          ],


          CompanyName: [
            {required: true, message: '请填写公司名称', trigger: 'blur'}
          ],
          BusiLicenseNum: [
            {required: true, message: '请填写营业执照号', trigger: 'blur'}
          ],
          IdCardNumber: [
            {required: true, message: '请填写身份证号码', trigger: 'blur'}
          ],


          BankUserName: [
            {required: true, message: '请填写开户名称', trigger: 'blur'}
          ],
          AccountOpenCompany: [
            {required: true, message: '请填写开户公司名称', trigger: 'blur'}
          ],
          AccountBranch: [
            {required: true, message: '请填写开会银行支行', trigger: 'blur'}
          ],
          BankAccount: [
            {required: true, message: '请填写银行账号', trigger: 'blur'}
          ]
        },
        imgPreview: '',
        imgPreviewShow: false,
        MediaId: 0,
        userType: ''
      };
    },
    components: {
      // 面包屑
      crumbs,
      // 审核弹框
      confirmDialog
    },
    methods: {
      beforeAvatarUpload1(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isJPG && !isPNG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
          return;
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
          return;
        }
        let formdata = new FormData();
        formdata.append('imageUrl1', file);
        UploadImg(formdata).then(res => {
          if(res === 'error') {
            this.$message.error('图片上传失败');
            return;
          }
          if (this.ruleForm.Nature === 0) {
            this.ruleForm.IdCardFrontImg = res;
            this.imageUrl1 = URL.createObjectURL(file);
          } else {
            this.ruleForm.BusinessLicenseImg = res;
            this.imageUrl3 = URL.createObjectURL(file);
          }
        })
        return isJPG && isLt2M && isPNG;
      },
      beforeAvatarUpload2(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 5;

        if (!isJPG && !isPNG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
          return;
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
          return;
        }
        let formdata = new FormData();
        formdata.append('imageUrl2', file);
        UploadImg(formdata).then(res => {
          if(res === 'error') {
            this.$message.error('图片上传失败');
            return;
          }
          if (this.ruleForm.Nature === 0) {
            this.ruleForm.IdCardRearImg = res;
            this.imageUrl2 = URL.createObjectURL(file);
          } else {
            this.ruleForm.OpeningPermissionImg = res
            this.imageUrl4 = URL.createObjectURL(file);
          }
        })
        return isJPG && isLt2M && isPNG;
      },
      formInit() {
        if (this.ruleForm && this.ruleForm.Nature === 0) {
          this.rules.CompanyName[0].required = false;
          this.rules.BusiLicenseNum[0].required = false;
          this.rules.IdCardNumber[0].required = true;
          this.rules.TelePhone[0].required = true;
          // this.rules.BankUserName[0].required = true;
          // this.rules.AccountOpenCompany[0].required = false;
          this.ruleForm.BusiLicenseNum = '91320981MA1MR2802U';
          this.ruleForm.CompanyName = '东台市善星科技有限公司';
        } else {
          this.rules.CompanyName[0].required = true;
          this.rules.BusiLicenseNum[0].required = true;
          this.rules.IdCardNumber[0].required = false;
          this.rules.TelePhone[0].required = false;
          // this.rules.BankUserName[0].required = false;
          // this.rules.AccountOpenCompany[0].required = true;
        }
      },
      changeMediaType(value) {
        this.formInit();
        if(value == 0) {
          this.ruleForm.BankUserName = this.oldRuleForm.BankUserName;
        } else {
          this.ruleForm.AccountOpenCompany = this.oldRuleForm.AccountOpenCompany;
        }
        this.$refs['ruleForm'].clearValidate();
      },
      imgView(index) {
        if (index === 1) {
          if(this.ruleForm && this.ruleForm.Nature === 0) {
            this.imgPreview = this.imageUrl1;
          } else {
            this.imgPreview = this.imageUrl3;
          }
        } else {
          if(this.ruleForm && this.ruleForm.Nature === 0) {
            this.imgPreview = this.imageUrl2;
          } else {
            this.imgPreview = this.imageUrl4;
          }
        }
        this.imgPreviewShow = true;
      },
      //返回上一页
      back() {
        window.location.href="/iad_customer/list?usertype=" + this.userType;
      },
      //修改媒体商信息
      EditUserDetail(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            EditUserDetail(this.ruleForm).then(res => {
              if(res.success) {
                this.ruleForm = {};
                // this.MediaId = res.UserId || 0;
                // this.$router.push({
                //   query:merge(this.$route.query,{'id': res.UserId || 0})
                // });
                this.$message({
                  type: 'success',
                  message:'保存成功'
                });
                // this.GetMediaUserInfo();
                window.location.href="/iad_customer/list?usertype=" + this.userType;
              } else {
                this.$message.error(res.message);
              }
            }).catch( () => {
              this.$message.error('保存失败,请联系后台开发人员');
            })
          } else {
            this.$message.error('请将信息填写完整');
            return false;
          }
        });
      },
      //获取媒体运营
      GetSourceOperatorUserList() {
        GetSourceOperatorUserList().then(res => {
          if (res.success) {
            if(res.list) {
              res.list.forEach(data => {
                this.operatingList.push({
                  value: data.id,
                  label: data.name
                })
              });
            }

          }
        })
      },
      //获取媒介
      getSourceman() {
        getSourceman().then(res => {
          if (res.success) {
            if(res.list) {
              res.list.forEach(data => {
                this.mediumList.push({
                  value: data.id,
                  label: data.name
                })
              })
            }
          }
        })
      },
      //获取合同公司
      GetContractCompanyEnum() {
        GetContractCompanyEnum().then(res => {
          if(res.list) {
            res.list.forEach((data, index) => {
              this.mediaCompanyList.push({
                value: data,
                label: data
              })
            })
          }
        })
      },
      //获取媒体商信息
      GetMediaUserInfo() {
        GetMediaUserInfo({
          id: this.MediaId || 0
        }).then(res => {
          if (res.success) {
            if (!res.model) {
              this.$set(this.ruleForm, 'Nature', 1);
              this.$set(this.ruleForm, 'ContractCompany', '霍尔果斯巨掌互动科技有限公司');
              this.$set(this.ruleForm, 'Status', 1);
              return;
            } else {
              this.ruleForm = res.model;
              this.oldRuleForm = JSON.parse(JSON.stringify(res.model));
              // 个人图片显示
              if (this.ruleForm.IdCardFrontImg && this.ruleForm.IdCardFrontImg.indexOf('error') < 0) {
                this.imageUrl1 = JSON.parse(JSON.stringify(this.ruleForm.IdCardFrontImg));
                this.ruleForm.IdCardFrontImg = '/ImgUpload' + this.ruleForm.IdCardFrontImg.split('ImgUpload')[1];
              } else {
                this.imageUrl1 = '';
              }
              if (this.ruleForm.IdCardRearImg && this.ruleForm.IdCardRearImg.indexOf('error') < 0) {
                this.imageUrl2 = JSON.parse(JSON.stringify(this.ruleForm.IdCardRearImg));
                this.ruleForm.IdCardRearImg = '/ImgUpload' + this.ruleForm.IdCardRearImg.split('ImgUpload')[1];
              } else {
                this.imageUrl1 = '';
              }
              // 公司图片显示
              if (this.ruleForm.BusinessLicenseImg && this.ruleForm.BusinessLicenseImg.indexOf('error') < 0) {
                this.imageUrl3 = JSON.parse(JSON.stringify(this.ruleForm.BusinessLicenseImg));
                this.ruleForm.BusinessLicenseImg = '/ImgUpload' + this.ruleForm.BusinessLicenseImg.split('ImgUpload')[1];
              } else {
                this.imageUrl3 = '';
              }
              if (this.ruleForm.OpeningPermissionImg && this.ruleForm.OpeningPermissionImg.indexOf('error') < 0) {
                this.imageUrl4 = JSON.parse(JSON.stringify(this.ruleForm.OpeningPermissionImg));
                this.ruleForm.OpeningPermissionImg = '/ImgUpload' + this.ruleForm.OpeningPermissionImg.split('ImgUpload')[1];
              } else {
                this.imageUrl4 = '';
              }
            }
            if(this.MediaId == 0) {
              this.$set(this.ruleForm, 'Nature', 1);
              this.$set(this.ruleForm, 'ContractCompany', '霍尔果斯巨掌互动科技有限公司');
              this.$set(this.ruleForm, 'Status', 1);
            }

          } else {
            this.$set(this.ruleForm, 'Nature', 1);
            this.$set(this.ruleForm, 'ContractCompany', '霍尔果斯巨掌互动科技有限公司');
            this.$set(this.ruleForm, 'Status', 1);
          }

          this.formInit();
        })
      }
    },
    computed: {},
    watch:{
      '$route' (to, from) {

      }
    },
    mounted() {
      this.MediaId = this.$route.query.id || '0';
      this.userType = this.$route.query.userType || '';
      this.GetSourceOperatorUserList();
      this.getSourceman();
      this.GetContractCompanyEnum();
      this.GetMediaUserInfo();
    }
  };
</script>
<style lang="scss" scoped>
  @import "../../common/scss/color.scss";

  .main-view {
    margin: 0 10px;
    h3 {
      font-size: 20px !important;
      text-align: center;
      padding-top: 20px;
    }
    .view-form-list {
      margin: 20px;
      .list-title {
        display: inline-block;
        line-height: 60px;
      }
      ul {
        padding-top: 30px;
        margin: 0 20px;
        border-top: 1px solid #D4D4D4;
        &:after {
          content: '';
          display: block;
          clear: both;
        }
        li {
          float: left;
          width: 33.333%;
          text-align: center;
          line-height: 60px;
          height: 60px;
          label {
            width: 120px;
            display: inline-block;
          }
          .el-input {
            width: 200px;
          }
          .el-form-item__content {
            width: 200px !important;
          }
        }
      }
      .form-upload-img {
        border-top: 1px solid #D4D4D4;
        padding-top: 30px;
        &:after {
          content: '';
          display: block;
          clear: both;
        }
        .upload-left, .upload-right {
          float: left;
          width: 420px;
          min-height: 300px;
          margin-left: 80px;
          .update {
            padding-bottom: 10px;
            overflow: hidden;
          }
          .upload-result-img {
            width: 100%;
            height: 300px;
            border: 1px solid #D4D4D4;
            line-height: 300px;
            text-align: center;
            background: #E5E5E5;
            overflow: hidden;
            i {
              line-height: inherit;
              color: #D2D4D7;
              font-size: 48px;
            }
            img {
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
          }
        }
      }
    }
    .form-btn {
      padding: 40px 0;
      text-align: center;
      .el-button {
        width: 100px;
        margin-right: 20px;
        margin-left: 20px;
      }
    }

  }

  /*上传图片样式*/
  .avatar-uploader {
    border: 1px solid #D4D4D4;
    width: 100%;
    height: 300px;
    img {
      width: 420px;
      height: 300px;
    }
  }

  .upload-demo {
    display: inline-block;
    vertical-align: middle;
    float: right;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 420px;
    height: 300px;
    line-height: 300px;
    text-align: center;
  }

  .preview-img {
    img {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/media/media-add.vue